import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box } from '@honda-canada/design-system-react';
import themeStyles from './SpeedometerCharts.styles';
import getChartColor from '../utils';
const SpeedometerChartUi = ({ newValue = 99, color }) => {
    const dimensions = 120;
    const strokeWidth = 14;
    const halfDimensions = dimensions * 0.5;
    const radius = halfDimensions - strokeWidth * 0.5;
    const circumference = 2 * Math.PI * radius;
    const strokeVal = (newValue * circumference) / 100;
    const dashVal = `${strokeVal} ${circumference}`;
    const trackStyle = { strokeWidth: strokeWidth / 2 };
    const indicatorStyle = { strokeWidth, strokeDasharray: dashVal };
    const rotateVal = `rotate(-90 ${halfDimensions},${halfDimensions})`;
    const Container = themeStyles.apply('div', 'Container');
    const SVG = themeStyles.apply('svg', 'SVG');
    const ChartTrack = themeStyles.apply('circle', 'ChartTrack');
    const ChartTrackIndicator = themeStyles.apply('circle', 'ChartTrackIndicator');
    const ChartValueContainer = themeStyles.apply(Box, 'ChartValueContainer');
    const ChartValueSymbol = themeStyles.apply(Box, 'ChartValueSymbol');
    const ChartValue = themeStyles.apply('span', 'ChartValue');
    return (_jsxs(Container, { children: [_jsxs(SVG, { "data-testid": "speedometer-chart", width: dimensions, height: dimensions, color: getChartColor(color), children: [_jsx(ChartTrack, { r: radius, cx: halfDimensions, cy: halfDimensions, transform: rotateVal, style: trackStyle, className: "chart-track" }), _jsx(ChartTrackIndicator, { r: radius, cx: halfDimensions, cy: halfDimensions, transform: rotateVal, style: indicatorStyle, className: "chart-indicator" })] }), _jsxs(ChartValueContainer, { children: [_jsx(ChartValue, { "data-testid": "chart-value", className: "chart-value", children: newValue.toString() }), _jsx(ChartValueSymbol, { children: "%" })] })] }));
};
export default SpeedometerChartUi;
